import { render, staticRenderFns } from "./FriendActivityLine.vue?vue&type=template&id=2298a648&scoped=true"
import script from "./FriendActivityLine.vue?vue&type=script&lang=js"
export * from "./FriendActivityLine.vue?vue&type=script&lang=js"
import style0 from "./FriendActivityLine.vue?vue&type=style&index=0&id=2298a648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2298a648",
  null
  
)

export default component.exports